<template>
    <div>
        <div class>
            <Steps :active="5" :stepsShow=true align-center>
                <Step :title="$t('offering.offbase')" @click.native="on_click('offbaseAdd')" />
                <Step :title="$t('offering.offeringResources')" @click.native="on_click('offeringResourcesAdd')" />
                <Step :title="$t('offering.offconditionAdd')" @click.native="on_click('offconditionAdd')" />
                <Step :title="$t('offering.offnoticeAdd')" @click.native="on_click('offnoticeAdd')" />
                <Step :title="$t('offering.offpriceAdd')" @click.native="on_click('offpriceAdd')" />
                <Step :title="$t('offering.offinvestAdd')" @click.native="on_click('offinvestAdd')" />
                <Step :title="$t('offering.offabilityAdd')"  @click.native="on_click('offabilityAdd')" />
            </Steps>
        </div>
        <br/>
        <div class='divMessage'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ message }}</div>
        <br/>
        <el-card class="aui-card--fill"
                 shadow="never">
            <el-form
                    label-position="left"
                    class="demo-dynamic"
                    disabled
            >
                <el-row>
                    <div class="investigationTitle">
                      {{$t('offering.courseInvestigation')}}
                      <el-tooltip placement="bottom-start" effect="light" >
                        <div slot="content">
                          当前显示为默认问卷，如有需求可点击添加问卷更换其他问卷。若无需学员反馈课程满意度，此处可为空。
                        </div>
                        <em class="el-icon-question" style="color: #1C69D3"></em>
                      </el-tooltip>
                    </div>
                    <el-col :span="4"><div class="grid-content" /></el-col>
                    <el-col :span="10">
                        <el-table
                                ref="questionnaireTable"
                                :data="initQuestionnaireData.courseInvestigationList"
                                border
                                lazy
                                style="width: 100%">
                            <el-table-column
                                    prop="investigationName"
                                    align="center"
                                    :label="$t('offering.investigationName')"/>
                            <el-table-column
                                    prop="investigationAddress"
                                    align="center"
                                    :label="$t('offering.investigationAddress')"/>
<!--                            <el-table-column-->
<!--                                    align="center"-->
<!--                                    :label="$t('handle')"-->
<!--                                    width="120">-->
<!--                                <template slot-scope="scope">-->
<!--                                  <el-button size="small" disabled> 删除 </el-button>-->
<!--                                </template>-->
<!--                            </el-table-column>-->
                        </el-table>
                    </el-col>
                </el-row>
                <el-row>
                    <div class="investigationTitle">
                      {{$t('offering.trainerInvestigation')}}
                      <el-tooltip placement="bottom-start" effect="light" >
                        <div slot="content">
                          当前显示为默认问卷，如有需求可点击添加问卷更换其他问卷。若无需学员反馈老师满意度，此处可为空。
                        </div>
                        <em class="el-icon-question" style="color: #1C69D3"></em>
                      </el-tooltip>
                    </div>
                    <el-col :span="4"><div class="grid-content" /></el-col>
                    <el-col :span="10">
                        <el-table
                                :data="initQuestionnaireData.trainerInvestigationList"
                                style="width: 100%">
                            <el-table-column
                                    prop="investigationName"
                                    align="center"
                                    :label="$t('offering.investigationName')"/>
                            <el-table-column
                                    prop="investigationAddress"
                                    align="center"
                                    :label="$t('offering.investigationAddress')"/>
<!--                            <el-table-column-->
<!--                                    align="center"-->
<!--                                    :label="$t('handle')"-->
<!--                                    width="120">-->
<!--                                <template slot-scope="scope">-->
<!--                                  <el-button size="small" disabled> 删除 </el-button>-->
<!--                                </template>-->
<!--                            </el-table-column>-->
                        </el-table>
                        <!--  -->
                    </el-col>
                </el-row>

            </el-form>

        </el-card>
        <div>
            <el-row style="float:right; margin-bottom: 60px;">
                <el-col :span="16"><div class="grid-content" /></el-col>
                <el-button @click="sendEdit" v-if = initIsShowEdit
                           type="primary">{{ $t("course.edit") }}</el-button>
                <el-button @click="btnSaveNextStep"
                           type="primary">{{ $t("course.next") }}</el-button>
            </el-row>
        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 基本信息   offbaseAdd
// 报名条件   offconditionAdd
// 报名通知   offnoticeAdd
// 价格相关   offpriceAdd
// 调查问卷   offinvestAdd
// 能力项设置 offabilityAdd
import Steps from '../../common/steps/index'
import Step from '../../common/steps/src/step'
export default {
// import引入的组件需要注入到对象中才能使用
  components: { Steps, Step },
  props: ['message', 'passOfferingId'],
  inject: ['toTop'],
  data () {
    return {
      initIsShowEdit:'',
      dialogTableVisible: false,
      dialogFlag: '',
      initQuestionnaireData: {
        offeringId: '',
        courseInvestigationList: [],
        trainerInvestigationList: []
      },
      dataForm: {
        offeringId: ''
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.dataForm.offeringId = this.$route.query.offeringId
    this.$eventHub.$on('offbaseAdd', data => {
      this.again()
    })
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    console.log('mounted')
  },
  beforeCreate () {
    console.log('beforeCreate')
  }, // 生命周期 - 创建之前
  beforeMount () {
    console.log('beforeMount')
  }, // 生命周期 - 挂载之前
  beforeUpdate () {
    console.log('beforeUpdate')
  }, // 生命周期 - 更新之前
  updated () {
    console.log('updated')
  }, // 生命周期 - 更新之后
  beforeDestroy () {
    console.log('beforeDestroy')
  }, // 生命周期 - 销毁之前
  destroyed () {
    console.log('destroyed')
  }, // 生命周期 - 销毁完成
  activated () {
    if (this.$route.query.offeringId !== undefined && this.$route.query.offeringId !== '') {
      // #TODO 再次进入页面初始化数据
      console.log('再次进入 abilityItems')
      console.log(this.$route.query.offeringId)
      this.init(this.$route.query.offeringId)
    }
    if (this.$route.query.isShowEdit !== undefined && this.$route.query.isShowEdit !== '') {
        this.initIsShowEdit = this.$route.query.isShowEdit
    }
  },
  // 方法集合
  methods: {
    sendEdit(){
      console.log("sendEdit")
      this.$router.push({ path: 'learning-offering-offeringEdit', query: { offeringId: this.dataForm.offeringId } })
    },
    // 设置初始化为空
    again () {
      this.initQuestionnaireData = {}
    },
    // 初始化数据
    init (offeringId) {
      this.getInitList(offeringId)
    },
    // 获取初始化问卷信息列表
    getInitList (offeringId) {
      this.$request.get('/learning/offeringInvestigation/' + offeringId).then((res, total, code, data) => {
        if (data.data) {
          this.initQuestionnaireData = data.data
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 保存方法
    btnSave () {
      // TODO 成功调用  this.sendSave()
    },
    // 保存并下一步
    btnSaveNextStep () {
      // TODO  成功调用 this.sendMsg()
      this.sendMsg()
    },
    // 向父页面传递消息 跳转下一页面
    sendMsg () {
      this.toTop()
      this.$emit('onShowModer', 'offabilitysend')
    },
    // 向父页面传递消息 保存页面
    sendSave () {
      this.$emit('onShowModer', 'offabilitySave')
    },
    // 点击导航跳转页面
    on_click (e) {
      this.$emit('onShowModer', e)
    },
    // 保存勾选内容
    resetForm (formName) {
      console.log('xxxxx')
      this.multipleTable = this.$refs.multipleTable.selection
      console.log(this.$refs.multipleTable)
      this.multipleSelection = []
      // this.initQuestionnaireData = []
      console.log(this.multipleTable)
      for (let i = 0; i < this.multipleTable.length; i++) {
        console.log(this.multipleTable[i].investigationName)
        this.multipleSelection.push({ 'investigationName': this.multipleTable[i].investigationName, 'row': this.multipleTable[i].row })
      }
      this.initQuestionnaireData.courseInvestigationList = this.multipleSelection
      // 添加后提示信息
      this.$message({
        message: this.$t('course.addOK'),
        type: 'success',
        duration: 500
      })
      this.popover4Show = false
    },
    // 点击多选框触发
    handleSelectionChange (val) {
      // this.multipleSelection = val
      // console.log('val ')
      // console.log(val)
      // this.multipleSelectionChange = val
    },
    // 删除行
    deleteRow (index, rows) {
      console.log('deleteRow')

      // console.log(this.multipleSelection)
      // this.$refs.multipleTable.toggleRowSelection(this.questionnaireData[index], false)
      this.$refs.multipleTable.clearSelection()
      rows.splice(index, 1)
      // console.log(rows)
      if (rows) {
        for (let i = 0; i < rows.length; i++) {
          // console.log(rows[i].row)
          this.$refs.multipleTable.toggleRowSelection(this.questionnaireData[rows[i].row])
        }
      }
    },
    // 取消按钮
    btnCancel () {
      this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tabRemove()
      }).catch((err) => {
        console.log(err)
      })
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    }
  }
}
</script>
<style lang='scss' scoped>
    // @import url(); 引入公共css类
    .grid-content {
        border-radius: 4px;
        min-height: 20px;
    }
    .investigationTitle {
        padding: 20px;
        font-size: 15px;
        text-align: center;
        font-weight: bold;
        width: 80%;
    }
</style>
